import React, { useContext } from "react";
import { useParams, useLocation } from "react-router-dom";
import { OrderTickSVG } from "../../../assets/svg/allSvg";
import { CurrencyContext } from "../../../provider/CurrencyProvider";

const TrackOrder = () => {
  const [currentStep, setCurrentStep] = React.useState(0);
  const numberOfSteps = 4;

  const { calculatedPrice, getCurrencySymbol } = useContext(CurrencyContext);


  const activeColor = (index) =>
    currentStep >= index ? "bg-[#72C62F]" : "bg-gray-300";
  const isFinalStep = (index) => index === numberOfSteps - 1;

  const goToNextStep = () =>
    setCurrentStep((prev) => (prev === numberOfSteps - 1 ? prev : prev + 1));
  const goToPreviousStep = () =>
    setCurrentStep((prev) => (prev <= 0 ? prev : prev - 1));

  const location = useLocation();
  const { orderID } = useParams();
  const order = location.state?.order;
  return (
    // <div className="w-screen h-screen flex items-center justify-center">
    <div className="w-[1014px] h-[590px] bg-[#FFF9F2] rounded-r-[10px] flex flex-col pl-[32px] pr-[38px] pb-[25px] pt-[41px] gap-y-[13px]">
      <div className="w-[954px] h-[121px] rounded-[10px] bg-white py-[25px] pl-[26px] pr-[35px] flex flex-row items-center justify-between gap-x-[24px] drop-shadow-[0_0px_2px_rgba(0,0,0,0.10)]">
        <img src={order?.images[0]} alt="" className="w-[57px] h-[69px]" />
        <div className="flex items-center justify-between flex-row w-full">
          <div className="flex flex-col items-start justify-between">
            <h4 className="w-auto h-[24px] text-start text-black font-semibold text-[16px]">
              {order?.productTitle}
            </h4>
            <p className="w-[150px] h-[21px] font-medium text-[14px] text-start text-black">
              Order ID : {order?.orderID}
            </p>
            <p className="w-auto h-[21px] font-medium text-[14px] text-start text-black">
              Seller : {order?.storeName}
            </p>
          </div>
          <div className="flex flex-col items-end justify-center">
            <p className="w-[105px] h-[24px] font-medium text-black text-end text-[16px]">
              Order Value :
            </p>
            <p className="w-[170px] h-[24px] font-semibold text-[16px] text-end text-black">
              {getCurrencySymbol()}{" "} {calculatedPrice(order?.totalAmount)}
            </p>
          </div>
        </div>
      </div>

      <div className="w-[954px] h-[247px] rounded-[10px] bg-white py-[25px] pl-[26px] pr-[35px] flex flex-col gap-x-[24px] drop-shadow-[0_0px_2px_rgba(0,0,0,0.10)]">
        <div className="flex flex-row items-center justify-between w-full">
          <h4 className="w-[116px] h-[24px] font-semibold text-[16px] text-black text-start">
            Track Delivery
          </h4>
          <p className="w-auto h-[21px] font-semibold text-[14px] text-black text-end">
            Order ID :{" "}
            <span className="text-[14px] font-semibold text-black">
              {order?.orderID}
            </span>
          </p>
        </div>

        <hr className="w-[185px] bg-[#FF6300] rounded-full h-[1px] pb-[3px] mt-[5px]" />

        <div className="flex flex-col items-center justify-center w-[885px] h-[162px] gap-y-[18px]">
          <div className="flex items-center w-[791px]">
            {Array.from({ length: numberOfSteps }).map((_, index) => (
              <React.Fragment key={index}>
                <div
                  className={`w-[36px] h-[36px] flex items-center justify-center text-white rounded-full ${activeColor(
                    index
                  )}`}
                >
                  {currentStep >= index && (
                    // <img
                    //   src={OrderTickSVG}
                    //   alt="step-icon"
                    //   className="w-[18px] h-[14px] object-contain"
                    // />
                    <p>
                      {OrderTickSVG}
                    </p>
                  )}
                </div>
                {isFinalStep(index) ? null : (
                  <div
                    className={`w-[215px] border-dotted h-1 ${activeColor(
                      index
                    )}`}
                  ></div>
                )}
              </React.Fragment>
            ))}
          </div>
          <div className="w-[856px] h-[71px] flex flex-row items-center justify-between">
            <div className="flex flex-col items-center justify-between text-center h-[71px]">
              <h1 className="w-[109px] h-[21px] text-black font-semibold text-[14px]">
                Order Received
              </h1>
              <p className="w-[104px] h-[18px] font-medium text-[12px] text-black">
                28 February 2024
              </p>
              <p className="w-[104px] h-[18px] font-medium text-[12px] text-black">
                11 : 09 AM
              </p>
            </div>

            <div className="flex flex-col items-center justify-between text-center h-[71px]">
              <h1 className="w-[97px] h-[21px] text-black font-semibold text-[14px]">
                Order Packed
              </h1>
              <p className="w-[104px] h-[18px] font-medium text-[12px] text-black">
                28 February 2024
              </p>
              <p className="w-[104px] h-[18px] font-medium text-[12px] text-black">
                11 : 09 AM
              </p>
            </div>

            <div className="flex flex-col items-center justify-between text-center h-[71px]">
              <h1 className="w-[103px] h-[21px] text-[#C1C1C1] font-semibold text-[14px]">
                Order Shipped
              </h1>
            </div>

            <div className="flex flex-col items-center justify-between text-center h-[71px]">
              <h1 className="w-[113px] h-[21px] text-[#C1C1C1] font-semibold text-[14px]">
                Order Delivered
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
};

export default TrackOrder;
